module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("What They Didn’t Teach You in Spanish Class")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Table of Contents"
    }
  }, [_c('p', {
    staticClass: "h2f1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_c('b', [_vm._v("Table of Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "abk"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Book"
    }
  }, [_c('b', [_vm._v("Using This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("1 Meet & Greet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("2 Friends & Enemies")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("3 Booze, Bars, & Clubs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("4 Sexy Body, Ugly Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("5 Nice & Naughty")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("6 Smack Talk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("7 Pop Culture & Technology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("8 Sports & Games")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter "), _c('b', [_vm._v("9 Food & Drink")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "aut"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/Author",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0156f4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 69
// module chunks = 0